import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminNotificationsService } from '@services';

/**
 * Opens by itself after login while this browser has neither allowed nor blocked notifications, explains what they
 * are for, and asks. "Allow" is a click — exactly what browsers require before showing their own permission prompt.
 * "Not now" snoozes it for a week (AdminNotificationsService.snoozePrompt).
 */
@Component({
  selector: 'app-notifications-prompt',
  template: `
    <div class="noti-prompt" dir="rtl">
      <div class="noti-prompt__icon"><i class="mdi mdi-bell-ring-outline"></i></div>
      <h4 class="noti-prompt__title">{{ 'adminNotiPromptTitle.value' | translate }}</h4>
      <p class="noti-prompt__lead">{{ 'adminNotiPromptLead.value' | translate }}</p>
      <ul class="noti-prompt__list">
        <li><i class="mdi mdi-briefcase-outline"></i>{{ 'adminNotiPromptJobs.value' | translate }}</li>
        <li><i class="mdi mdi-post-outline"></i>{{ 'adminNotiPromptPosts.value' | translate }}</li>
        <li><i class="mdi mdi-receipt"></i>{{ 'adminNotiPromptInvoices.value' | translate }}</li>
      </ul>
      <p class="noti-prompt__note">{{ 'adminNotiPromptNote.value' | translate }}</p>
      <div class="noti-prompt__actions">
        <button type="button" class="btn btn-primary noti-prompt__allow" [disabled]="busy" (click)="allow()">
          {{ 'adminNotiPromptAllow.value' | translate }}
        </button>
        <button type="button" class="btn btn-light" [disabled]="busy" (click)="later()">
          {{ 'adminNotiPromptLater.value' | translate }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .noti-prompt {
        padding: 2rem 1.75rem 1.5rem;
        text-align: center;
      }
      .noti-prompt__icon {
        width: 4.5rem;
        height: 4.5rem;
        margin: 0 auto 1rem;
        border-radius: 50%;
        background: #fff4cc;
        color: #f6bd00;
        font-size: 2.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .noti-prompt__title {
        font-weight: 700;
        margin-bottom: 0.5rem;
      }
      .noti-prompt__lead {
        color: #5b6170;
        margin-bottom: 1rem;
      }
      .noti-prompt__list {
        list-style: none;
        padding: 0;
        margin: 0 auto 1rem;
        max-width: 22rem;
        text-align: start;
      }
      .noti-prompt__list li {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        padding: 0.45rem 0;
        border-bottom: 1px solid #f0f0f2;
      }
      .noti-prompt__list li:last-child {
        border-bottom: 0;
      }
      .noti-prompt__list i {
        color: #f6bd00;
        font-size: 1.25rem;
      }
      .noti-prompt__note {
        font-size: 0.85rem;
        color: #8a8f9c;
        margin-bottom: 1.25rem;
      }
      .noti-prompt__actions {
        display: flex;
        gap: 0.75rem;
        justify-content: center;
      }
      .noti-prompt__allow {
        background: #f6bd00;
        border-color: #f6bd00;
        color: #070b14;
        font-weight: 600;
        min-width: 9rem;
      }
    `,
  ],
})
export class NotificationsPromptComponent {
  busy = false;
  constructor(
    public activeModal: NgbActiveModal,
    private notifications: AdminNotificationsService,
  ) {}

  async allow() {
    this.busy = true;
    const state = await this.notifications.enable();
    this.activeModal.close(state);
  }

  later() {
    this.notifications.snoozePrompt();
    this.activeModal.close('later');
  }
}
